module.exports = __webpack_public_path__ + "static/105_home-57ac093a9e9540c010726dc088b0567c.png";